import React from "react";
import { ButtonGroup, FontButton } from "./style";

const fonts = [
    { name: "Manrope", fontFamily: "'Manrope', sans-serif", fontWeight: 500 },
    { name: "Bebas Neue", fontFamily: "'Bebas Neue', sans-serif", fontWeight: 400 },
    { name: "Noto Serif", fontFamily: "'Noto Serif', serif", fontWeight: 500 },
    { name: "Playfair Display", fontFamily: "'Playfair Display', serif", fontWeight: 700 },
    { name: "Anton", fontFamily: "'Anton', sans-serif", fontWeight: 400 },
    { name: "DynaPuff", fontFamily: "'DynaPuff', cursive", fontWeight: 400 },
    { name: "Knewave", fontFamily: "'Knewave', cursive", fontWeight: 400 },
    { name: "Notable", fontFamily: "'Notable', sans-serif", fontWeight: 400 },
    { name: "Russo One", fontFamily: "'Russo One', sans-serif", fontWeight: 400 },
    { name: "Cookie", fontFamily: "'Cookie', cursive", fontWeight: 400 },
    { name: "Cascadia Mono", fontFamily: "'Cascadia Mono', monospace", fontWeight: 700 },
    { name: "Unkempt", fontFamily: "'Unkempt', cursive", fontWeight: 700 },
];

const TextStyleSelector = ({ selectedFont, onChange }) => {
    return (
        <ButtonGroup>
            {fonts.map(({ name, fontFamily, fontWeight }, index) => (
                <FontButton
                    key={index}
                    font={fontFamily}
                    weight={fontWeight}
                    active={selectedFont === name}
                    onClick={() => onChange && onChange(name)}
                    title={name}
                >
                Ag
                </FontButton>
            ))}
        </ButtonGroup>
    );
};

export default TextStyleSelector;
